import numeral from "numeral";
import moment from 'moment';

function cpf_cnpj_validate(value) {
   function cpf_validate(c) {

      if (c[0].repeat(11) === c)
         return false;

      let r;
      let s = 0;

      for (let i = 1; i <= 9; i++)
         s = s + parseInt(c[i - 1]) * (11 - i);

      r = (s * 10) % 11;

      if ((r === 10) || (r === 11))
         r = 0;

      if (r !== parseInt(c[9]))
         return false;

      s = 0;

      for (let i = 1; i <= 10; i++)
         s = s + parseInt(c[i - 1]) * (12 - i);

      r = (s * 10) % 11;

      if ((r === 10) || (r === 11))
         r = 0;

      if (r !== parseInt(c[10]))
         return false;

      return true;
   }

   function cnpj_validate(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g,'');
       
      if(cnpj == '') return false;
      
      if (cnpj.length != 14)
            return false;

      if (cnpj == "00000000000000" || 
            cnpj == "11111111111111" || 
            cnpj == "22222222222222" || 
            cnpj == "33333333333333" || 
            cnpj == "44444444444444" || 
            cnpj == "55555555555555" || 
            cnpj == "66666666666666" || 
            cnpj == "77777777777777" || 
            cnpj == "88888888888888" || 
            cnpj == "99999999999999")
            return false;
            
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0,tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
               pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
            return false;
            
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
               pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
            return false;
            
      return true;
   }

   let federalId = (value) ? value.match(/\d+/g).map(String).join('') : '';

   if (federalId.length === 11 && !cpf_validate(federalId)) {
      return 'CPF Inválido!';
   } else if (federalId.length === 14 && !cnpj_validate(federalId)) {
      return 'CNPJ Inválido!';
   } else if ([0, 11, 14].indexOf(federalId.length) === -1) {
      return 'Número Inválido!';
   }

   return true;

}


const Rules = {
   required: (v) => !!v || v == '0' || 'Requerido',
   dateMDY: (v) => {
      function isValid(d) {
         return moment(d, 'MM/DD/YYYY').isValid();
      }

      return !v || isValid(v) || 'Data Inválida';

   },
   dateDMY: (v) => {
      function isValid(d) {
         return moment(d, 'DD/MM/YYYY').isValid();
      }

      return !v || isValid(v) || 'Data Inválida';

   },
   email: (value) => {
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return (value) ? (pattern.test(value) || 'Email inválido') : (!value)
   },
   gtZero: (v) => numeral(v).value() > 0 || 'Informar valor',
   cpf_cnpj: (v) => cpf_cnpj_validate(v)
};

export default Rules;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@consigmais-team/vue-common/components/validationRules.js
// module id = Gfhl
// module chunks = 0